import React, { Component } from 'react';
import {Badge,Button,Col,Card,CardBody,FormGroup,Input,InputGroup,InputGroupButton,PaginationItem,PaginationLink,
  Row,Table} from 'reactstrap';
import Pagination from '../../components/Pagination';
import {user_type} from '../../constants';

// Firebase
import { app } from '../../base';

const TableRow = (props) => {
  let status = parseInt(props.data.status) && 1;
  let address = [];
  let address_no = [];

  if (props.data.building_no) {
    address_no.push(props.data.building_no);
  }
  if (props.data.door_no) {
    address_no.push(props.data.door_no);
  }
  if (address_no.length == 2) {
    address_no = address_no.join('/');
  }
  if (props.data.neighborhood) {
    address.push(props.data.neighborhood);
  }
  if (props.data.street) {
    address.push(props.data.street);
  }
  if (address_no) {
    address.push(address_no);
  }
  if (props.data.province) {
    address.push(props.data.province);
  }
  if (props.data.city) {
    address.push(props.data.city);
  }
  address = address.join(', ')

  let date = '';
  if (props.data.last_login) {
    date = new Date(props.data.last_login);
    date = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  }
  
  return (
    <tr>
      <td>{(props.data.email || '')}</td>
        <td>{user_type[(props.data.user_type || 0)]}</td>
        <td>{(props.data.user_name || '')}</td>
        <td>{(props.data.real_name || '')}</td>
        <td>{address}</td>
        <td>{(props.data.shop_name || '')}</td>
        <td>{(props.data.phone || '')}</td>
        <td>{(props.data.area || '')}</td>
        <td>{date}</td>
        <td><Badge color={status?'success':'secondary'} onClick={()=>props.changeStatus(props.rowKey,status)} style={{cursor:'pointer'}}>{status?'Active':'Inactive'}</Badge></td>
    </tr>
  );
}

class Users extends Component {
  constructor() {
    super();
    this.uid = sessionStorage.getItem('uid');
    this.state = {
      rows: [],
      pageOfItems: []
    };

    this.changeStatus = this.changeStatus.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }

  componentWillMount() {
    app.database().ref('/users').on('value', (snapshot) => {
      var users = snapshot.val();
      var rows = [];
      for (var key in users) {
        rows.push(<TableRow key={key} data={users[key]} rowKey={key} changeStatus={this.changeStatus} />);
      }
      this.setState({rows:rows});
    });
  }

  changeStatus(key, status){
    if (this.uid == key) return;

    app.database().ref('users/' + key).update({
      status: 1-status
    });
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    app.database().ref("users").orderByChild("user_name").startAt(searchText).endAt(searchText+"\uf8ff").on("value", (snapshot)=>{
      var users = snapshot.val();
      var rows = [];
      for (var key in users) {
        rows.push(<TableRow key={key} data={users[key]} rowKey={key} changeStatus={this.changeStatus} />);
      }
      this.setState({rows:rows});
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Col md="4">
                  <FormGroup>
                    <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.entryForm = form }}>
                      <InputGroup>
                        <Input size="10" type="text" placeholder="Enter user name here" innerRef={(input) => { this.searchInput = input }}/>
                        <InputGroupButton>
                          <Button color="info">Search</Button>
                        </InputGroupButton>
                      </InputGroup>
                    </form>
                  </FormGroup>
                </Col>  
                <Table bordered striped responsive size="sm">
                  <thead>
                  <tr>
                    <th>Email</th>
                    <th>User Type</th>
                    <th>User Name</th>
                    <th>Real Name</th>
                    <th>Address</th>
                    <th>Shop Name</th>
                    <th>Phone</th>
                    <th>Area</th>
                    <th>Last Login</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Users;


// WEBPACK FOOTER //
// ./src/views/Users/Users.js